import { encryptSensitiveData } from '@lcsc-design/utils/crypto';

import { isLocal } from '@/utils/baseUrl';
import { doGet, doPost } from '@/utils/request';

// client请求接口
let domain = 'lcscMemberUrl';
if (isLocal) {
  domain = 'https://devmember.szlcsc.com';
}

// 收藏商品
export function favoriteAdd(query) {
  return doGet(domain, '/async/favorite/add/dynamic', query);
}
// 到货通知初始化
export function arriveInit(query) {
  return doGet(domain, '/async/arrive/init/v2', query);
}
// 到货通知提交
export function arriveInsert({ productId, phone, email }) {
  const fd = new FormData();
  fd.append('productId', productId);
  fd.append('email', encryptSensitiveData(email));
  fd.append('phone', encryptSensitiveData(phone));
  return doPost(domain, '/async/arrive/insert/v2', fd);
}
// 列表显示收藏
export function selectProductFavorite(query) {
  return doGet(domain, '/select/product/favorite/v2', query);
}
